import { RenderStateStruct, WordArtRenderProps } from '../../type';

export function renderBg({
    renderStateStruct,
    bgList,
}: {
    renderStateStruct: RenderStateStruct;
    bgList: WordArtRenderProps['bgList'];
}) {
    const { scheduleRatio } = renderStateStruct;

    bgList.forEach((bg, id) => {
        renderStateStruct.bgStructList.push({
            id,
            width: (bg?.width * scheduleRatio) >> 0,
            height: (bg?.height * scheduleRatio) >> 0,
            offset: {
                x: bg.localBounds.x * scheduleRatio,
                y: bg.localBounds.y * scheduleRatio,
            },
            detail: bg,
            cmds: undefined,
        });
    });
}
